module.exports = __webpack_public_path__ + "img/wallet-big.d3672945.svg";